var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomSanctionList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 26H10V22H6V26ZM6 34H10V30H6V34ZM6 18H10V14H6V18ZM14 26H42V22H14V26ZM14 34H42V30H14V34ZM14 14V18H42V14H14Z",
    fill: "#EE781C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomSanctionList);
export default __webpack_public_path__ + "static/media/customSanctionList.799bf580b00996b80f2c8a9dd85df1b8.svg";
export { ForwardRef as ReactComponent };